module.exports = __webpack_public_path__ + "img/_19.48444f4a.webp";